export default __webpack_public_path__ + "static/banner-d6de2610eb28329950c7f0ec69ac6096.png";